module.exports = __webpack_public_path__ + "static/media/cancel-circle.42dc4016.svg";